import React, { useEffect, useState } from 'react';
import { Link as Anchor } from "react-router-dom";
import './NumerosMain.css'
import baseURL from '../../url';
import useApiWithLoader from '../../../hooks/useApiWithLoader';
export default function NumerosMain() {
    const [numeros, setNumeros] = useState([]);
    const { apiCall } = useApiWithLoader();

    useEffect(() => {
        cargarNumeros();
    }, []);

    const cargarNumeros = () => {
        apiCall(async () => {
            const response = await fetch(`${baseURL}/numeroGet.php`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data && Array.isArray(data.numeros)) {
                setNumeros(data.numeros.reverse().slice(0, 5));
            } else {
                setNumeros([]);
            }
        }).catch(error => {
            console.error('Error loading numeros:', error);
            setNumeros([]);
        });
    };

    return (

        <div className='table-containerProductos'>
            <div className='deFlexMore'>
                <h3>Ultimas {Array.isArray(numeros) ? numeros.length : 0} numeros </h3>
                <Anchor to={`/dashboard/numeros`} className='logo'>
                    Ver más
                </Anchor>
            </div>
            <table className='table'>
                <thead>
                    <tr>
                        <th>Numero</th>
                        <th>Estado</th>
                        <th>Nombre</th>
                        <th>Telefono</th>
                        <th>Identificacion</th>
                        <th>Direccion</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(numeros) && numeros.length > 0 ? numeros.map(item => (
                        <tr key={item.idNumero}>
                            <td>{item.numero}</td>
                            <td style={{
                                color: item?.estado === 'disponible' ? '#008000' : item?.estado === 'reservado' ? '#FF0000' : '#DAA520',
                            }}>
                                {`${item?.estado}`}
                            </td>
                            <td>{item?.nombre}</td>
                            <td>{item.telefono}</td>
                            <td>{item.identificacion}</td>
                            <td>{item.direccion}</td>
                        </tr>
                    )) : (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                No hay números disponibles
                            </td>
                        </tr>
                    )}
                </tbody>

            </table>
        </div>

    );
};
